module.exports = "../../../../platform/assets/pageMainIcon/business_baobiaochaxunlei2.svg";